import AlphaModuleCreator from '@/moduleCreators/AlphaModuleCreator';

import { srpDuckPreset } from '@/ducks/presets/index.js';

const alphaModule = AlphaModuleCreator().extend({
    duck: srpDuckPreset,
    ctxMiddleware: ({ ctxMiddleware }) => async (ctx) => {
        const {
            alpha_showcase: [isAlphaEnabled],
        } = ctx.useFeatures([
            'alpha_showcase',
        ]);

        if (isAlphaEnabled) {
            // call the original ctx-middleware and pass it the ctx;
            await ctxMiddleware(ctx);
        }
    },
});

export default alphaModule;
